"use client";

import React from "react";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "@/shadcn-components/ui/tabs";
import { TradeScreen } from "@/components/trades-view";
import { HistoryScreen } from "@/components/history-view";
import { TradeDesktopContent, TradeHistoryDesktopContent, EconomicCalendarDesktopContent, MailboxDesktopContent, NewsDesktopContent } from "./content";
import JournalDesktopContent from "./content/JournalDesktopContent";
import TerminalDesktopContent from "@/components/terminal/TerminalDesktopContent";
import { DENSITY } from "@/lib/density-scale";

export default function FooterDesktop() {
  return (
    <div className="h-full w-full bg-background border-t border-border flex flex-col">
      <Tabs defaultValue="trades" className="w-full h-full flex flex-col">
        <TabsList className={`grid w-full grid-cols-7 rounded-none ${DENSITY.TOOLBAR_H} flex-shrink-0`}>
          <TabsTrigger value="trades" className="rounded-none text-xs">
            Trades
          </TabsTrigger>
          <TabsTrigger value="history" className="rounded-none text-xs">
            History
          </TabsTrigger>
          <TabsTrigger value="journal" className="rounded-none text-xs">
            Journal
          </TabsTrigger>
          <TabsTrigger value="news" className="rounded-none text-xs">
            News
          </TabsTrigger>
          <TabsTrigger value="mailbox" className="rounded-none text-xs">
            Mailbox
          </TabsTrigger>
          <TabsTrigger
            value="economicCalendar"
            className="rounded-none text-xs"
          >
            Economic Calendar
          </TabsTrigger>
          <TabsTrigger value="terminal" className="rounded-none text-xs">
            Terminal
          </TabsTrigger>
        </TabsList>

        <TabsContent value="trades" className="mt-0 flex-1 overflow-hidden">
          <TradeDesktopContent />
        </TabsContent>

        <TabsContent value="history" className="mt-0 flex-1 overflow-hidden">
          <TradeHistoryDesktopContent />
        </TabsContent>

        <TabsContent value="journal" className="mt-0 flex-1 overflow-hidden">
          <JournalDesktopContent />
          {/* Journal content will be added here */}
        </TabsContent>

        <TabsContent value="news" className="mt-0 flex-1 overflow-hidden">
          <NewsDesktopContent />
        </TabsContent>

        <TabsContent value="mailbox" className="mt-0 flex-1 overflow-hidden">
          <MailboxDesktopContent />
        </TabsContent>

        <TabsContent value="economicCalendar" className="mt-0 flex-1 overflow-hidden">
          <EconomicCalendarDesktopContent />
        </TabsContent>

        <TabsContent value="terminal" className="mt-0 flex-1 overflow-hidden">
          <TerminalDesktopContent />
        </TabsContent>
      </Tabs>
    </div>
  );
}
